import React, { useEffect, useState } from "react";

const WebGLLimitations = () => {
  const [limitations, setLimitations] = useState(null);

  useEffect(() => {
    const getWebGLLimitations = () => {
      const canvas = document.createElement("canvas");
      const gl =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

      if (!gl) {
        return {
          supported: false,
          message: "WebGL is not supported in this browser or device.",
        };
      }

      const info = {
        supported: true,
        maxTextureSize: gl.getParameter(gl.MAX_TEXTURE_SIZE),
        maxTextureUnits: gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS),
        maxVertexUniforms: gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS),
        maxFragmentUniforms: gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS),
        maxVaryings: gl.getParameter(gl.MAX_VARYING_VECTORS),
        maxRenderbufferSize: gl.getParameter(gl.MAX_RENDERBUFFER_SIZE),
        maxVertexAttributes: gl.getParameter(gl.MAX_VERTEX_ATTRIBS),
        maxViewportDims: gl.getParameter(gl.MAX_VIEWPORT_DIMS),
        renderer: gl.getParameter(gl.RENDERER),
        vendor: gl.getParameter(gl.VENDOR),
        version: gl.getParameter(gl.VERSION),
        shadingLanguageVersion: gl.getParameter(gl.SHADING_LANGUAGE_VERSION),
      };

      return info;
    };

    setLimitations(getWebGLLimitations());
  }, []);

  if (!limitations) return <p>Loading WebGL limitations...</p>;

  return (
    <div>
      <h3>WebGL Limitations</h3>
      {limitations.supported ? (
        <ul>
          <li>
            <strong>Max Texture Size:</strong> {limitations.maxTextureSize}
          </li>
          <li>
            <strong>Max Texture Units:</strong> {limitations.maxTextureUnits}
          </li>
          <li>
            <strong>Max Vertex Uniforms:</strong>{" "}
            {limitations.maxVertexUniforms}
          </li>
          <li>
            <strong>Max Fragment Uniforms:</strong>{" "}
            {limitations.maxFragmentUniforms}
          </li>
          <li>
            <strong>Max Varyings:</strong> {limitations.maxVaryings}
          </li>
          <li>
            <strong>Max Renderbuffer Size:</strong>{" "}
            {limitations.maxRenderbufferSize}
          </li>
          <li>
            <strong>Max Vertex Attributes:</strong>{" "}
            {limitations.maxVertexAttributes}
          </li>
          <li>
            <strong>Max Viewport Dimensions:</strong>{" "}
            {limitations.maxViewportDims.join(" x ")}
          </li>
          <li>
            <strong>Renderer:</strong> {limitations.renderer}
          </li>
          <li>
            <strong>Vendor:</strong> {limitations.vendor}
          </li>
          <li>
            <strong>Version:</strong> {limitations.version}
          </li>
          <li>
            <strong>Shading Language Version:</strong>{" "}
            {limitations.shadingLanguageVersion}
          </li>
        </ul>
      ) : (
        <p>{limitations.message}</p>
      )}
    </div>
  );
};

export default WebGLLimitations;
